<div class="dash-card no-padding">
    <div class="dash-card-header d-block" style="flex-direction: column;">
        <div class="row no-gutters">
            <div class="col-12">
                <div style="padding-bottom: 0;">
                    <h2>Usuários</h2>
                    <p>Visualize e gerencie os colaboradores do sistema.</p>
                </div>
            </div>

            <div class="col-12 d-flex justify-content-between align-items-center mt-5 px-0"
                *ngIf="loading || data.length > 0 || hasFilters">
                <div class="d-flex align-items-center">
                    <button type="button" class="sort-button mr-2"
                        (click)="refreshData()" [disabled]="loading">
                        <svg-icon src="assets/images/icon-renew.svg"></svg-icon>
                        <span>Atualizar</span>
                    </button>
                </div>

                <div class="d-flex align-items-center">
                    <app-button
                        *ngIf="hasFilters && permissionObj.canFilter && !loading"
                        [danger]="true" [outline]="true" class="add-button mr-2"
                        (onClick)="resetForm()">
                        <svg-icon src="assets/images/icon-times.svg"
                            class="filter-clear-icon"></svg-icon>
                        Limpar filtros
                    </app-button>

                    <app-button [inverted]="true" class="add-button mr-2"
                        (onClick)="toggleFilterModal()" [disabled]="loading"
                        *ngIf="permissionObj.canFilter && (loading || data.length > 0 || hasFilters)">
                        <svg-icon src="assets/images/icon_filter.svg"
                            class="mr-2"></svg-icon>
                        {{ hasFilters ? 'Editar filtros' : 'Filtrar listagem' }}
                    </app-button>
                </div>
            </div>

            <div class="col-12 mt-3 px-0"
                *ngIf="!loading && hasFilters && appliedFilters.length > 0">
                <div
                    class="d-flex flex-wrap align-items-center justify-content-end">
                    <app-filter-tag *ngFor="let filter of appliedFilters"
                        [label]="filter.label" [value]="filter.value">
                    </app-filter-tag>
                </div>
            </div>
        </div>
    </div>

    <div class="dash-card-body p-0">
        <!-- Loading skeleton -->
        <ng-container *ngIf="loading">
            <div class="table-responsive">
                <table class="dash-card-table">
                    <tbody>
                        <tr *ngFor="let item of [1,2,3,4,5,6,7,8]">
                            <td *ngFor="let col of [1,2,3,4]">
                                <ngx-skeleton-loader [theme]="{
                                    width: '100%',
                                    height: '16px'
                                  }">
                                </ngx-skeleton-loader>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>

        <!-- Table with data -->
        <ng-container *ngIf="!loading && data.length > 0">
            <div class="table-responsive">
                <table class="bordered">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Email</th>
                            <th>Departamento</th>
                            <th>Tipo</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let item of data">
                            <td>
                                <div class="dash-card-item-content">
                                    <div class="dash-card-item-content-title">
                                        {{item.name}}
                                    </div>
                                    <div
                                        class="dash-card-item-content-subtitle">
                                        {{formatCpf(item.document)}}
                                    </div>
                                </div>
                            </td>

                            <td>{{item.email}}</td>

                            <td>
                                <div class="department-cell">
                                    <span>{{getDepartmentName(item)}}</span>
                                    <app-tooltip *ngIf="isCommonUser(item)"
                                        text="Trocar departamento"
                                        position="top">
                                        <svg-icon
                                            src="assets/images/icon-arrows.svg"
                                            class="change-department-icon"
                                            (click)="openChangeDepartmentModal(item)"></svg-icon>
                                    </app-tooltip>
                                </div>
                            </td>

                            <td>{{getUserType(item)}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-container>

        <!-- Empty state - sem filtros -->
        <ng-container *ngIf="!loading && data.length === 0 && !hasFilters">
            <app-empty-content [isVisible]="true" [large]="true"
                title="Não há nenhum usuário para exibir"
                description="Não há colaboradores cadastrados no sistema no momento"
                icon="/assets/images/figure_3d_search.png">
            </app-empty-content>
        </ng-container>

        <!-- Empty state - com filtros -->
        <ng-container *ngIf="!loading && data.length === 0 && hasFilters">
            <app-empty-content [isVisible]="true" [large]="true"
                title="Não encontramos resultados para sua busca"
                description="Não há registros para o termo digitado, verifique a ortografia ou tente novamente com outras palavras"
                icon="/assets/images/figure_3d_search.png">
            </app-empty-content>
        </ng-container>
    </div>
</div>

<div class="col-12 ml-auto mr-auto" *ngIf="data.length > 0">
    <div class="dash-card-pagination">
        <app-pagination [data]="data" [count]="count" [show]="!loading"
            [offset]="offset" (onPageChange)="changePageData($event)"
            [resultsPerPage]="resultsPerPage" [totalPages]="totalPages"
            [currentPageFromApi]="currentPage" [dashPagination]="true">
        </app-pagination>
    </div>
</div>

<app-side-filter-modal [active]="showFilterModal" [formGroup]="filterForm"
    [loading]="loading" title="Filtrar listagem"
    [disableApplyButton]="!canApplyFilters" (onClose)="toggleFilterModal()"
    (onApply)="filterData()" (onReset)="resetForm()">
    <div class="row">
        <div class="col-12">
            <app-input [group]="filterForm" controlName="name"
                placeholder="Digite" label="Nome">
            </app-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-masked-input [group]="filterForm" controlName="document_number"
                label="CPF" mask="000.000.000-00">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-input [group]="filterForm" controlName="email"
                placeholder="Digite" label="Email">
            </app-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12">
            <app-select [items]="userTypeOptions" [group]="filterForm"
                controlName="user_type" placeholder="Selecione"
                label="Tipo de usuário">
            </app-select>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
    </div>
</app-side-filter-modal>

<app-side-modal [active]="showChangeDepartmentModal" title="Trocar departamento"
    (onClose)="closeChangeDepartmentModal()">
    <div class="row">
        <div class="col-12">
            <p *ngIf="selectedUserForDepartmentChange" class="mb-4">
                Alterando departamento de:
                <strong>{{selectedUserForDepartmentChange?.name}}</strong>
            </p>

            <app-select [items]="departmentOptions"
                [group]="changeDepartmentForm" controlName="department"
                placeholder="Selecione o departamento"
                label="Novo departamento">
            </app-select>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
    </div>

    <div class="row">
        <div
            class="col-12 d-flex justify-content-between align-items-center gap-3 department-modal-buttons">
            <app-button (onClick)="closeChangeDepartmentModal()"
                [phantom]="true">
                Cancelar
            </app-button>
            <app-button (onClick)="saveDepartmentChange()"
                [disabled]="savingDepartment || !changeDepartmentForm.valid">
                <span *ngIf="!savingDepartment">Salvar</span>
                <span *ngIf="savingDepartment">Salvando...</span>
            </app-button>
        </div>
    </div>
</app-side-modal>

<app-loading-spinner [active]="isLoadingDepartmentAction"></app-loading-spinner>